<div class="max-w-2xl mx-auto">
  <h1 class="text-2xl font-semibold text-gray-900 mb-6">{{ 'settings.title' | translate }}</h1>

  <div class="flex flex-col gap-3">
    <div class="bg-white rounded-lg border border-gray-200 flex-1">
      <a
        routerLink="/settings/used-controls"
        class="flex items-center justify-between p-4 hover:bg-gray-50 transition-colors cursor-pointer">
        <div class="flex items-center gap-4">
          <div class="shrink-0">
            <svg
              class="w-6 h-6 text-gray-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z" />
            </svg>
          </div>
          <div class="flex flex-col">
            <span class="text-base font-medium text-gray-900">{{
              'settings.viewUsedControls' | translate
            }}</span>
            <span class="text-sm text-gray-500">{{
              'settings.viewUsedControlsSubtitle' | translate
            }}</span>
          </div>
        </div>
        <div class="shrink-0">
          <svg class="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7" />
          </svg>
        </div>
      </a>
    </div>
    <div class="bg-white rounded-lg border border-gray-200 flex-1">
      <a
        routerLink="/settings/lang"
        class="flex items-center justify-between p-4 hover:bg-gray-50 transition-colors cursor-pointer">
        <div class="flex items-center gap-4">
          <div class="shrink-0">
            <svg
              class="w-6 h-6 text-gray-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div class="flex flex-col">
            <span class="text-base font-medium text-gray-900">{{
              'settings.language' | translate
            }}</span>
            <span class="text-sm text-gray-500">{{ 'settings.languageSubtitle' | translate }}</span>
          </div>
        </div>
        <div class="shrink-0">
          <svg class="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7" />
          </svg>
        </div>
      </a>
    </div>
    <div class="bg-white rounded-lg border border-gray-200 flex-1">
      <a
        routerLink="/settings/copy-contents"
        class="flex items-center justify-between p-4 hover:bg-gray-50 transition-colors cursor-pointer">
        <div class="flex items-center gap-4">
          <div class="shrink-0">
            <svg
              class="w-6 h-6 text-gray-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
            </svg>
          </div>
          <div class="flex flex-col">
            <span class="text-base font-medium text-gray-900">{{
              'settings.copyContents' | translate
            }}</span>
            <span class="text-sm text-gray-500">{{
              'settings.copyContentsSubtitle' | translate
            }}</span>
          </div>
        </div>
        <div class="shrink-0">
          <svg class="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7" />
          </svg>
        </div>
      </a>
    </div>
    <div class="bg-white rounded-lg border border-gray-200 flex-1">
      <a
        routerLink="/settings/document-properties"
        class="flex items-center justify-between p-4 hover:bg-gray-50 transition-colors cursor-pointer">
        <div class="flex items-center gap-4">
          <div class="shrink-0">
            <svg
              class="w-6 h-6 text-gray-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div class="flex flex-col">
            <span class="text-base font-medium text-gray-900">{{
              'settings.documentProperties' | translate
            }}</span>
            <span class="text-sm text-gray-500">{{
              'settings.documentPropertiesSubtitle' | translate
            }}</span>
          </div>
        </div>
        <div class="shrink-0">
          <svg class="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7" />
          </svg>
        </div>
      </a>
    </div>
    <div class="bg-white rounded-lg border border-gray-200 flex-1">
      <a
        routerLink="/tenants"
        class="flex items-center justify-between p-4 hover:bg-gray-50 transition-colors cursor-pointer">
        <div class="flex items-center gap-4">
          <div class="shrink-0">
            <svg
              class="w-6 h-6 text-gray-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
          </div>
          <div class="flex flex-col">
            <span class="text-base font-medium text-gray-900">{{
              'settings.tenants' | translate
            }}</span>
            <span class="text-sm text-gray-500">{{ 'settings.tenantsSubtitle' | translate }}</span>
          </div>
        </div>
        <div class="shrink-0">
          <svg class="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7" />
          </svg>
        </div>
      </a>
    </div>
  </div>

  <div class="mt-6 flex items-center justify-center gap-2 text-sm text-gray-500">
    <span>{{ 'settings.version' | translate }}: {{ buildVersion || '-' }}</span>
    <button
      type="button"
      class="inline-flex items-center justify-center rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-700"
      aria-label="{{ 'settings.copyVersion' | translate }}"
      title="{{ 'settings.copyVersion' | translate }}"
      (click)="copyBuildVersion()">
      <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
      </svg>
    </button>
    @if (copyFeedback() === 'copied') {
      <span class="text-xs text-green-700">{{ 'settings.copySucceeded' | translate }}</span>
    }
    @if (copyFeedback() === 'failed') {
      <span class="text-xs text-red-700">{{ 'settings.copyFailed' | translate }}</span>
    }
  </div>
</div>
